import {
  IsUUID,
  IsInt,
  IsOptional,
  IsNotEmpty,
  Min,
  Max,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateProgramConceptCompetencyDto {
  @ApiProperty({ description: 'Program concept UUID' })
  @IsUUID()
  @IsNotEmpty()
  programConceptId!: string

  @ApiProperty({ description: 'Program competency UUID' })
  @IsUUID()
  @IsNotEmpty()
  programCompetencyId!: string

  @ApiPropertyOptional({ description: 'Weight of the link (1-5)', default: 3 })
  @IsInt()
  @Min(1)
  @Max(5)
  @IsOptional()
  weight?: number
}
